<template>
  <div>
    <!-- 轮播图之后再完善 -->
    <!-- <div class="block">
      <el-carousel trigger="click" height="150px" :autoplay="false">
        <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <!-- 税收政策指引 -->
    <div class="wrapCon def-container">
      <div
        class="item"
        v-for="(item, index) in infoData"
        :key="index"
        @click="toPolicyDetail(item, 3)"
      >
        <img
          :src="srcUrl + item.barnnerimg.split(',')[0]"
          alt=""
          width="277"
          height="160"
        />
        <p class="title"><a :title="item.name">{{ item.name }}</a></p>
      </div>
      <!-- <div class="item" v-for="i in 6" :key="i">
        <img
          src="~@/assets/images/tips_2.png"
          alt=""
          width="277"
          height="160"
        />
        <p class="title">标题</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      srcUrl:
        "http://222.141.201.20:8060//balocal-api/dev-api/fileManageApi/common/fileView/",
      infoData: [],
    };
  },
  created() {
    this.getPolicyGuideInfo();
  },
  mounted() {},
  methods: {
    toPolicyDetail(val, type) {
      let that = this;
 /*     let { href } = that.$router.resolve({
        path: "/notice/detail/" + val.id + "?detailType=" + type,
        query:{
          showSideNav:true,
        }
      });
      window.open(href, "_blank");*/

      this.$router.push({
        path: "/notice/detail/" + val.id + "?detailType=" + type,
        query:{
          showSideNav:true,
        }
      })
    },
    getPolicyGuideInfo() {
      let url = "/dev-api/policyexplain/list";
      let that = this;
      that.$httpApi
        .get(url)
        .then((res) => {
          that.infoData = res.rows;
        })
        .catch((e) => {});
    },
  },
};
</script>

<style lang='scss' scoped>
.block {
  background-color: #ccc;
}
.wrapCon {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-evenly;
  .item {
    min-width: 277px;
    min-height: 180px;
    margin: 36px;
    box-shadow: 0 0 10px#ccc;
    &:hover {
      transform: scale(1.05);
      transition: all 0.3s;
    }
  }
  .title {
    font-size: 18px;
    color: #333;
    width: 277px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    line-height: 18px;
    margin-bottom: 10px;
    a {
      color:#333;
    }
  }
}
</style>
